<template>
  <div>
    <v-dialog
    :value="value" 
    @input="$emit('input')"
    transition="fade-transition" 
    scrollable 
    width="800px" >
      <v-card>
        <v-card-title class="custom-card-title">
          Platforms
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="bg-white" style="margin-top:20px;">
          <inf-platform-data-table
            :items="platforms"
            :influencerID="influencerID"
            @showCompareModal="showCompareModal"
            @reload="reloadPage"
            @close="close"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- comparison modal -->
    <comparison-modal
      :influencer="compareDefaultInf"
      :compareInf="compareInf"
      v-model="comparisonDialog"
      v-if="compareDefaultInf"
      @mergeSuccess="mergeSuccess"
    />
  </div>
</template>
<script>
import InfPlatformDataTable from './DataTable';
import ComparisonModal from './ComparisonModal';
export default {
  name: 'InfPlatformsViewModal',
  props: {
    value: Boolean,
    influencerID: String,
    platforms: Array,
    influencer: Object
  },
  components: {
    ComparisonModal,
    InfPlatformDataTable
  },
  data () {
    return {
      compareDefaultInf: null,
      compareInf: null,
      comparisonDialog: false
    }
  },
  methods: {
    showCompareModal(inf) {
      this.compareDefaultInf = Object.assign({}, this.influencer)
      this.compareInf = Object.assign({}, inf)
      this.comparisonDialog = false
      setTimeout(() => {
        this.comparisonDialog = true
      }, 500)
    },
    mergeSuccess() {
      this.$emit('reload')
      this.close()
      this.$swal({
        text: 'Influencers Merged',
        type: 'success'
      });
    },
    reloadPage() {
      this.$emit('reload')
    },
    close() {
      this.$emit('input')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ViewModal.vue?4a80caa3